module.exports = __webpack_public_path__ + "img/maneken_pos_2_back.327b1031.png";